import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SkeletonView from '@@viewCommonComponents/groupProtection/SkeletonView.jsx';

const SouscriptionSupportingDocumentsGroupProtection = ({ getMiddleText }) => (
  <SkeletonView title={'Envoi des documents'} getMiddleText={getMiddleText} nextButtonIsHidden />
);

export default withMiddleFeatures(SouscriptionSupportingDocumentsGroupProtection);
